import gqlRequest from '@biuwer/core/src/graphql-request';
import i18n from '@biuwer/core/src/i18n';
import Auth from "@biuwer/redux/src/system/auth/auth-lib";
import { defaultContext } from "@biuwer/redux/src/config/constants";
import { addNotification } from "@biuwer/redux/src/system/notifications/notifications-actions";

import {
    DATA_PORTALS_LIST,
    DATA_PORTAL_DETAIL,
    DATA_PORTAL_CUSTOM_URL_VERIFICATION,
} from "./data-portals-gql";
import request from '@biuwer/common/src/libs/superagent';

/**
 * Action types
 */
export const DATA_PORTALS_INITIALIZE = "DATA_PORTALS_INITIALIZE";
export const DATA_PORTAL_DETAIL_INITIALIZE = "DATA_PORTAL_DETAIL_INITIALIZE";
export const DATA_PORTALS_LIST_INITIALIZE = "DATA_PORTAL_LIST_INITIALIZE";

export const DATA_PORTALS_FETCH_REQUEST = "DATA_PORTALS_FETCH_REQUEST";
export const DATA_PORTALS_FETCH_SUCCESS = "DATA_PORTALS_FETCH_SUCCESS";
export const DATA_PORTALS_FETCH_ERROR = "DATA_PORTALS_FETCH_ERROR";

export const DATA_PORTAL_FETCH_REQUEST = "DATA_PORTAL_FETCH_REQUEST";
export const DATA_PORTAL_FETCH_SUCCESS = "DATA_PORTAL_FETCH_SUCCESS";
export const DATA_PORTAL_FETCH_ERROR = "DATA_PORTAL_FETCH_ERROR";

export const DATA_PORTAL_CHANGE_STATUS_REQUEST = 'DATA_PORTAL_CHANGE_STATUS_REQUEST';
export const DATA_PORTAL_CHANGE_STATUS_SUCCESS = 'DATA_PORTAL_CHANGE_STATUS_SUCCESS';
export const DATA_PORTAL_CHANGE_STATUS_ERROR = 'DATA_PORTAL_CHANGE_STATUS_ERROR';

export const DATA_PORTAL_CREATE_REQUEST = "DATA_PORTAL_CREATE_REQUEST";
export const DATA_PORTAL_CREATE_SUCCESS = "DATA_PORTAL_CREATE_SUCCESS";
export const DATA_PORTAL_CREATE_ERROR = "DATA_PORTAL_CREATE_ERROR";

export const DATA_PORTAL_UPDATE_REQUEST = "DATA_PORTAL_UPDATE_REQUEST";
export const DATA_PORTAL_UPDATE_SUCCESS = "DATA_PORTAL_UPDATE_SUCCESS";
export const DATA_PORTAL_UPDATE_ERROR = "DATA_PORTAL_UPDATE_ERROR";

export const DATA_PORTAL_DELETE_REQUEST = "DATA_PORTAL_DELETE_REQUEST";
export const DATA_PORTAL_DELETE_SUCCESS = "DATA_PORTAL_DELETE_SUCCESS";
export const DATA_PORTAL_DELETE_ERROR = "DATA_PORTAL_DELETE_ERROR";

export const DATA_PORTAL_ADD_ADMINISTRATOR_REQUEST = "DATA_PORTAL_ADD_ADMINISTRATOR_REQUEST";
export const DATA_PORTAL_ADD_ADMINISTRATOR_SUCCESS = "DATA_PORTAL_ADD_ADMINISTRATOR_SUCCESS";
export const DATA_PORTAL_ADD_ADMINISTRATOR_ERROR = "DATA_PORTAL_ADD_ADMINISTRATOR_ERROR";
export const DATA_PORTAL_ADMINISTRATOR_ALREADY_IN_PORTAL = "DATA_PORTAL_ADMINISTRATOR_ALREADY_IN_PORTAL";

export const DATA_PORTAL_DELETE_ADMINISTRATOR_REQUEST = "DATA_PORTAL_DELETE_ADMINISTRATOR_REQUEST";
export const DATA_PORTAL_DELETE_ADMINISTRATOR_SUCCESS = "DATA_PORTAL_DELETE_ADMINISTRATOR_SUCCESS";
export const DATA_PORTAL_DELETE_ADMINISTRATOR_ERROR = "DATA_PORTAL_DELETE_ADMINISTRATOR_ERROR";

export const DATA_PORTAL_ADD_VIEWER_REQUEST = "DATA_PORTAL_ADD_VIEWER_REQUEST";
export const DATA_PORTAL_ADD_VIEWER_SUCCESS = "DATA_PORTAL_ADD_VIEWER_SUCCESS";
export const DATA_PORTAL_ADD_VIEWER_ERROR = "DATA_PORTAL_ADD_VIEWER_ERROR";
export const DATA_PORTAL_VIEWER_ALREADY_IN_PORTAL = "DATA_PORTAL_VIEWER_ALREADY_IN_PORTAL";

export const DATA_PORTAL_DELETE_VIEWER_REQUEST = "DATA_PORTAL_DELETE_VIEWER_REQUEST";
export const DATA_PORTAL_DELETE_VIEWER_SUCCESS = "DATA_PORTAL_DELETE_VIEWER_SUCCESS";
export const DATA_PORTAL_DELETE_VIEWER_ERROR = "DATA_PORTAL_DELETE_VIEWER_ERROR";

export const DATA_PORTAL_URL_IS_AVAILABLE_REQUEST = "DATA_PORTAL_URL_IS_AVAILABLE_REQUEST";
export const DATA_PORTAL_URL_IS_AVAILABLE_SUCCESS = "DATA_PORTAL_URL_IS_AVAILABLE_SUCCESS";
export const DATA_PORTAL_URL_IS_AVAILABLE_ERROR = "DATA_PORTAL_URL_IS_AVAILABLE_ERROR";

export const DATA_PORTAL_CUSTOM_URL_VERIFY_REQUEST = "DATA_PORTAL_CUSTOM_URL_VERIFY_REQUEST";
export const DATA_PORTAL_CUSTOM_URL_VERIFY_SUCCESS = "DATA_PORTAL_CUSTOM_URL_VERIFY_SUCCESS";
export const DATA_PORTAL_CUSTOM_URL_VERIFY_ERROR = "DATA_PORTAL_CUSTOM_URL_VERIFY_ERROR";


/**
 * Generic skeleton handler
 */
function generateSkeleton(type, body, context = defaultContext, showNotification = true) {
    let skeleton = { type, context };
    let notification;

    const typeSuffix = type.substring(type.lastIndexOf('_') + 1);

    switch (typeSuffix) {
        case "REQUEST":
            skeleton = { ...skeleton, isFetching: true, issue: false };
            break;
        case "ERROR":
            skeleton = {
                ...skeleton,
                isFetching: false,
                issue: true,
                issuePayload: {
                    status: body.status,
                    code: body.statusCode,
                    message: body.message
                }
            };
            break;
        case "SUCCESS":
            skeleton = {
                ...skeleton,
                isFetching: false,
                issue: body.status === 2,
                payload: body
            };

            if (body.status === 2) {
                skeleton.issuePayload = {
                    status: body.status,
                    code: body.issuePayload?.code,
                    message: body.message
                };
            }
            break;
        default:
            break;
    }

    switch (type) {
        case DATA_PORTAL_CREATE_SUCCESS:
            skeleton.created = true;
            notification = {
                styleType: 'success',
                message: i18n.t('notifications.createSuccess', {
                    name: i18n.t('dataPortals.title'),
                    context: 'male',
                    count: 1
                })
            };
            break;

        case DATA_PORTAL_UPDATE_SUCCESS:
            skeleton.updated = true;
            notification = {
                styleType: 'success',
                message: i18n.t('notifications.updateSuccess', {
                    name: i18n.t('dataPortals.title'),
                    context: 'male',
                    count: 1
                })
            };
            break;

        case DATA_PORTAL_DELETE_SUCCESS:
            skeleton.deleted = true;
            notification = {
                styleType: 'success',
                message: i18n.t('notifications.deleteSuccess', {
                    name: i18n.t('dataPortals.title'),
                    context: 'male',
                    count: 1
                })
            };
            break;

        case DATA_PORTAL_ADD_ADMINISTRATOR_SUCCESS:
            notification = {
                styleType: 'success',
                message: i18n.t('notifications.addSuccess', {
                    name: i18n.t('admin.users.title'),
                    context: 'male',
                    count: 1
                })
            };
            break;
        case DATA_PORTAL_DELETE_ADMINISTRATOR_SUCCESS:
            notification = {
                styleType: 'success',
                message: i18n.t('notifications.unassignSuccess', {
                    name: i18n.t('admin.users.title'),
                    context: 'male',
                    count: 1
                })
            };
            break;
        // Editors Case
        case DATA_PORTAL_ADD_VIEWER_SUCCESS:
            notification = {
                styleType: 'success',
                message: i18n.t('notifications.addSuccess', {
                    name: i18n.t('dataPortals.title'),
                    context: 'male',
                    count: 1
                })
            };
            break;
        case DATA_PORTAL_DELETE_VIEWER_SUCCESS:
            notification = {
                styleType: 'success',
                message: i18n.t('notifications.unassignSuccess', {
                    name: i18n.t('dataPortals.title'),
                    context: 'male',
                    count: 1
                })
            };
            break;

        case DATA_PORTAL_ADMINISTRATOR_ALREADY_IN_PORTAL:
        case DATA_PORTAL_VIEWER_ALREADY_IN_PORTAL:
            notification = {
                styleType: 'error',
                message: i18n.t('dataPortals.userAlreadyInDataPortalMessage')
            };
            break;

        case DATA_PORTAL_URL_IS_AVAILABLE_ERROR:
            notification = {
                styleType: 'error',
                message: i18n.t('dataPortals.urlNotAvailableMessage')
            };
            break;

        case DATA_PORTAL_CREATE_ERROR:
        case DATA_PORTAL_UPDATE_ERROR:
        case DATA_PORTAL_DELETE_ERROR:
        case DATA_PORTAL_CHANGE_STATUS_ERROR:
        case DATA_PORTAL_ADD_ADMINISTRATOR_ERROR:
        case DATA_PORTAL_DELETE_ADMINISTRATOR_ERROR:
        case DATA_PORTAL_ADD_VIEWER_ERROR:
        case DATA_PORTAL_DELETE_VIEWER_ERROR:
            notification = {
                styleType: 'error',
                message: i18n.t('notifications.error')
            };
            break;

        default:
            break;
    }

    return (dispatch) => {
        dispatch(skeleton);
        if (notification && showNotification) {
            dispatch(addNotification(notification));
        }
    };
}

/**
 * Initialization actions
 */
export const initializeDataPortals = (context = defaultContext) => ({
    type: DATA_PORTALS_INITIALIZE,
    context
});

export const initializeDataPortalDetail = (context = defaultContext) => ({
    type: DATA_PORTAL_DETAIL_INITIALIZE,
    context
});

export const initializeDataPortalList = (context = defaultContext) => ({
    type: DATA_PORTALS_LIST_INITIALIZE,
    context
});

/**
 * CRUD actions
 */
export const getDataPortalsList = (query = {}, context = defaultContext, gql = DATA_PORTALS_LIST) => {
    return async (dispatch) => {
        dispatch(generateSkeleton(DATA_PORTALS_FETCH_REQUEST, null, context));
        try {
            const response = await gqlRequest({
                queryName: "readDataPortals",
                queryGql: gql,
                token: Auth.getLocalJwt(),
            });
            dispatch(generateSkeleton(DATA_PORTALS_FETCH_SUCCESS, response, context));
        } catch (err) {
            dispatch(generateSkeleton(DATA_PORTALS_FETCH_ERROR, err, context));
        }
    };
};

export const getDataPortal = (portalId, context = defaultContext, gql = DATA_PORTAL_DETAIL) => {
    return async (dispatch) => {
        dispatch(generateSkeleton(DATA_PORTAL_FETCH_REQUEST, null, context));

        try {
            const response = await gqlRequest({
                queryName: "readDataPortal",
                queryGql: gql,
                token: Auth.getLocalJwt(),
                variables: [{
                    type: "Float!",
                    name: "_id",
                    data: Number(portalId)
                }]
            });
            dispatch(generateSkeleton(DATA_PORTAL_FETCH_SUCCESS, response, context));
        } catch (err) {
            dispatch(generateSkeleton(DATA_PORTAL_FETCH_ERROR, err, context));
        }
    };
};

export const createDataPortal = (dataPortal, context = defaultContext, gql = DATA_PORTAL_DETAIL) => {
    return async (dispatch) => {
        dispatch(generateSkeleton(DATA_PORTAL_CREATE_REQUEST, null, context));

        try {
            const response = await gqlRequest({
                queryType: "mutation",
                queryName: "createDataPortal",
                queryGql: gql,
                token: Auth.getLocalJwt(),
                variables: [{
                    type: "NewDataPortalInput!",
                    name: "dataPortal",
                    data: dataPortal
                }]
            });
            dispatch(generateSkeleton(DATA_PORTAL_CREATE_SUCCESS, response, context));
        } catch (err) {
            if (err.message === "DATA_PORTAL_URL_DUPLICATED") {
                dispatch(generateSkeleton(DATA_PORTAL_URL_IS_AVAILABLE_ERROR, err, context));
            } else {
                dispatch(generateSkeleton(DATA_PORTAL_CREATE_ERROR, err, context));
            }
        }
    };
};

export const updateDataPortal = (dataPortal, context = defaultContext, gql = DATA_PORTAL_DETAIL) => {
    return async (dispatch) => {
        dispatch(generateSkeleton(DATA_PORTAL_UPDATE_REQUEST, null, context));

        try {
            const response = await gqlRequest({
                queryType: "mutation",
                queryName: "updateDataPortal",
                queryGql: gql,
                token: Auth.getLocalJwt(),
                variables: [{
                    type: "DataPortalInput!",
                    name: "dataPortal",
                    data: dataPortal
                }]
            });
            dispatch(generateSkeleton(DATA_PORTAL_UPDATE_SUCCESS, response, context));
        } catch (err) {
            dispatch(generateSkeleton(DATA_PORTAL_UPDATE_ERROR, err, context));
        }
    };
};

export const deleteDataPortal = (portalId, context = defaultContext, gql = DATA_PORTAL_DETAIL) => {
    return async (dispatch) => {
        dispatch(generateSkeleton(DATA_PORTAL_DELETE_REQUEST, null, context));
        try {
            const response = await gqlRequest({
                queryType: "mutation",
                queryName: "deleteDataPortal",
                queryGql: gql,
                token: Auth.getLocalJwt(),
                variables: [{
                    type: "Float!",
                    name: "_id",
                    data: Number(portalId)
                }]
            });
            dispatch(generateSkeleton(DATA_PORTAL_DELETE_SUCCESS, response, context));
        } catch (err) {
            dispatch(generateSkeleton(DATA_PORTAL_DELETE_ERROR, err, context));
        }
    };
};

/**
 * System Data Portals: Add users to data portal action
 * @param dataPortalId
 * @param users
 * @param context
 * @param gql
 */
export function addUsersToDataPortal(dataPortalId, users, type, context = defaultContext, gql = DATA_PORTAL_DETAIL) {
    return async dispatch => {
        try {
            const query = {
                query: `mutation($dataPortalId: Float!, $users: [Float!]!, $type: String!) {
                    addUsersToDataPortal(_id: $dataPortalId, users: $users, type: $type) {
                        ${gql}
                    }
                }`,
                variables: {
                    dataPortalId: Number(dataPortalId),
                    users,
                    type
                }
            };

            const token = Auth.getLocalJwt();
            dispatch(generateSkeleton(DATA_PORTAL_ADD_ADMINISTRATOR_REQUEST, null, context));

            const res = await request
                .post('/api/gql/')
                .send(query)
                .set('Authorization', `Bearer ${token}`)
                .on('response', (response) => Auth.checkResponse(response));

            if (res) {
                const errors = res.body.errors || [];

                const conflictingError = errors.find(err => err.message === 'DATA_PORTAL_USER_ALREADY_IN_PORTAL');

                if (conflictingError) {
                    const errorType =
                        type === 'administrators'
                            ? DATA_PORTAL_ADMINISTRATOR_ALREADY_IN_PORTAL
                            : DATA_PORTAL_VIEWER_ALREADY_IN_PORTAL;

                    dispatch(generateSkeleton(errorType, conflictingError.message, context));
                } else if (errors.length > 0) {
                    dispatch(generateSkeleton(DATA_PORTAL_ADD_ADMINISTRATOR_ERROR, 'Error adding users to data portal', context));
                } else if (res.body?.data?.addUsersToDataPortal) {
                    dispatch(generateSkeleton(DATA_PORTAL_ADD_ADMINISTRATOR_SUCCESS, res.body.data.addUsersToDataPortal, context));
                }
            }
        } catch (e) {
            dispatch(generateSkeleton(DATA_PORTAL_ADD_ADMINISTRATOR_ERROR, e, context));
        }
    };
}

/**
 * System Data Portals: Delete users from data portal action
 * @param dataPortalId
 * @param users
 * @param context
 * @param gql
 */
export function deleteUsersFromDataPortal(dataPortalId, users, type, context = defaultContext, gql = DATA_PORTAL_DETAIL) {
    return async dispatch => {
        try {

            const query = {
                query: `mutation($dataPortalId: Float!, $users: [Float!]!, $type: String!) {
                    removeUsersFromDataPortal(_id: $dataPortalId, users: $users, type: $type) {
                        ${gql}
                    }
                }`,
                variables: {
                    dataPortalId: Number(dataPortalId),
                    users,
                    type
                }
            };

            const token = Auth.getLocalJwt();
            dispatch(generateSkeleton(DATA_PORTAL_DELETE_ADMINISTRATOR_REQUEST, null, context));

            const res = await request
                .post('/api/gql/')
                .send(query)
                .set('Authorization', `Bearer ${token}`)
                .on('response', (response) => Auth.checkResponse(response));

            if (res) {
                if (res.body.errors?.length > 0) {
                    dispatch(generateSkeleton(DATA_PORTAL_DELETE_ADMINISTRATOR_ERROR, 'Error deleting users from data portal', context));
                } else if (res.body?.data?.deleteUsersFromDataPortal) {
                    dispatch(generateSkeleton(DATA_PORTAL_DELETE_ADMINISTRATOR_SUCCESS, res.body.data.deleteUsersFromDataPortal, context));
                }
            }
        } catch (e) {
            dispatch(generateSkeleton(DATA_PORTAL_DELETE_ADMINISTRATOR_ERROR, e, context));
        }
    };
}

/**
 * Change data portal status action
 * @param portalId
 * @param status
 * @param context
 * @param gql
 */
export function changeDataPortalStatus(portalId, status, context = defaultContext, gql = DATA_PORTAL_DETAIL) {
    return async dispatch => {
        try {
            const query = {
                query: `mutation($portalId: Float!, $status: String!) {
                    changeDataPortalStatus( _id: $portalId, status: $status ) {
                        ${gql}
                    }
                }`,
                variables: {
                    portalId: Number(portalId),
                    status: status
                }
            };

            const token = Auth.getLocalJwt();
            dispatch(generateSkeleton(DATA_PORTAL_CHANGE_STATUS_REQUEST, null, context));

            const res = await request
                .post('/api/gql/')
                .send(query)
                .set('Authorization', `Bearer ${token}`)
                .on('response', (response) => Auth.checkResponse(response));

            if (res?.body?.errors?.length > 0) {
                dispatch(generateSkeleton(DATA_PORTAL_CHANGE_STATUS_ERROR, 'Error changing status of Data Portal', context));
            } else if (res.body?.data?.changeDataPortalStatus) {
                dispatch(generateSkeleton(DATA_PORTAL_CHANGE_STATUS_SUCCESS, res.body.data.changeDataPortalStatus, context));
            }
        } catch (e) {
            dispatch(generateSkeleton(DATA_PORTAL_CHANGE_STATUS_ERROR, e, context));
        }
    };
}

export function getDataPortalUrlAvailability(url, field, context = defaultContext, gql = "") {
    return async (dispatch) => {
        dispatch(generateSkeleton(DATA_PORTAL_URL_IS_AVAILABLE_REQUEST, null, context));

        try {
            const response = await gqlRequest({
                queryName: "isUrlAvailableInDataPortal",
                token: Auth.getLocalJwt(),
                variables: [
                    {
                        type: "String!",
                        name: "url",
                        data: url
                    },
                    {
                        type: "String!",
                        name: "field",
                        data: field
                    }
                ]
            });

            dispatch(generateSkeleton(DATA_PORTAL_URL_IS_AVAILABLE_SUCCESS, response, context));
        } catch (err) {
            dispatch(generateSkeleton(DATA_PORTAL_URL_IS_AVAILABLE_ERROR, err, context));
        }
    };
}

export function verifyDataPortalCustomUrl(customUrl, defaultUrl, context = defaultContext) {
    return async (dispatch) => {
        dispatch(generateSkeleton(DATA_PORTAL_CUSTOM_URL_VERIFY_REQUEST, null, context));
        try {
            const response = await gqlRequest({
                queryName: "verifyDataPortalCustomUrl",
                queryGql: DATA_PORTAL_CUSTOM_URL_VERIFICATION,
                token: Auth.getLocalJwt(),
                variables: [
                    { type: "String!", name: "customUrl", data: customUrl },
                    { type: "String!", name: "defaultUrl", data: defaultUrl }
                ]
            });
            dispatch(generateSkeleton(DATA_PORTAL_CUSTOM_URL_VERIFY_SUCCESS, response, context));
        } catch (err) {
            dispatch(generateSkeleton(DATA_PORTAL_CUSTOM_URL_VERIFY_ERROR, err, context));
        }
    };
}


